import { getAnswerPrompt, type StudentResultExercise } from "../../../../helpers/StudentResultModel";
import { getTeacherCommentTone } from "../../../../constants/StudentResultCommentTones";
import StudentResultAnswerBox from "../StudentResultAnswerBox";
import StudentResultAnswerCheck from "../StudentResultAnswerCheck";
import StudentResultAnswerRow from "../StudentResultAnswerRow";
import StudentResultAnswerScore from "../StudentResultAnswerScore";

interface StudentResultAnswersWriteSentenceProps {
    exercise: StudentResultExercise;
}

/** Task per word: the word above, the student's sentence on its evaluated lines below. */
const StudentResultAnswersWriteSentence = (props: StudentResultAnswersWriteSentenceProps) => {
    return (
        <ul
            className="flex flex-col"
            data-testid="student-result-answers-write-sentence"
        >
            {props.exercise.answers.map((answer, index) => (
                <StudentResultAnswerRow
                    key={answer.id}
                    isLast={index === props.exercise.answers.length - 1}
                    comment={answer.teacherComment}
                    tone={getTeacherCommentTone(answer.state)}
                >
                    <div className="flex flex-col gap-s">
                        <div className="flex items-center justify-between gap-s">
                            <p className="text-l text-p6-grey-dark px-xs min-w-[0] break-words">
                                {getAnswerPrompt(answer) || "—"}
                            </p>
                            <StudentResultAnswerScore
                                answer={answer}
                                isScored={props.exercise.isScored}
                            />
                        </div>
                        <div className="flex items-center gap-s">
                            <StudentResultAnswerBox
                                state={answer.state}
                                text={answer.studentAnswer}
                            />
                            <StudentResultAnswerCheck state={answer.state} />
                        </div>
                    </div>
                </StudentResultAnswerRow>
            ))}
        </ul>
    );
};

export default StudentResultAnswersWriteSentence;
